import { createContext } from "react";

/** The app layout's footer bar, for a descendant `FooterButtons` to portal into. */
export const FooterSlotContext = createContext<HTMLElement | null>(null);
